import { Checkbox, DataHeader, DataSource, Label, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutFleetCode extends Layout {
    checkboxIsDriver: Checkbox;
    checkboxIsTractor: Checkbox;
    checkboxIsTrailer: Checkbox;
    dataheaderFleetCode: DataHeader;
    labelAppliesTo: Label;
    panelAppliesTo: Panel;
    panelContent: Panel;
    panelTopRow: Panel;
    sourceFleet: DataSource;
    switchActive: Switch;
    textboxDailyDistGoal: Textbox;
    textboxDailyRevGoal: Textbox;
    textboxDescription: Textbox;
    textboxId: Textbox;
}
